import React from 'react'

import Search from '../search/Search'
import HeaderActionsV2 from './HeaderActionsV2'
import './header-view-v2.scss'

const HeaderViewV2 = ({ title, searchOptions, handlerHeaderActions }) => {
  return (
    <div className="header-view-v2">
      <h2 className="title__container"> {title} </h2>
      {(searchOptions || handlerHeaderActions) && (
        <div className="action-btns-v2">
          {searchOptions && <Search {...searchOptions} />}
          {handlerHeaderActions && (
            <HeaderActionsV2 {...handlerHeaderActions} />
          )}
        </div>
      )}
    </div>
  )
}

export default HeaderViewV2
